import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiHome, FiClock, FiFolder, FiCheckSquare, FiUsers, FiClipboard, FiCalendar, FiSettings, FiBarChart2 } from 'react-icons/fi';

export default function Layout() {
  const { user, logout, isAdmin, isManager, isHR } = useAuth();

  const navItems = [
    { to: '/', icon: <FiHome />, label: 'Dashboard', end: true },
    { to: '/timesheet', icon: <FiClock />, label: 'Timesheet' },
    { to: '/projects', icon: <FiFolder />, label: 'Projects' },
    { to: '/tasks', icon: <FiCheckSquare />, label: 'Tasks' },
    { to: '/leave', icon: <FiCalendar />, label: 'Leave' },
  ];

  const mgmtItems = [];
  if (isManager || isHR) {
    mgmtItems.push({ to: '/approvals', icon: <FiClipboard />, label: 'Approvals' });
  }
  if (isManager || isHR || isAdmin) {
    mgmtItems.push({ to: '/reports', icon: <FiBarChart2 />, label: 'Reports' });
  }
  if (isAdmin) {
    mgmtItems.push({ to: '/employees', icon: <FiUsers />, label: 'Employees' });
    mgmtItems.push({ to: '/admin/settings', icon: <FiSettings />, label: 'Settings' });
  }

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <h2>TimeTrack</h2>
          <small>Quadprosoft Technologies</small>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-section">Main</div>
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            >
              {item.icon} {item.label}
            </NavLink>
          ))}

          {mgmtItems.length > 0 && (
            <>
              <div className="sidebar-section">Management</div>
              {mgmtItems.map(item => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                >
                  {item.icon} {item.label}
                </NavLink>
              ))}
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">{user?.fullName}</div>
          <div className="sidebar-role">{user?.role} • {user?.employeeId}</div>
          <button className="sidebar-logout" onClick={logout}>Sign Out</button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
